import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReleaseDefinitionRevision } from 'src/app/models/release-definition-revision';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-release-history-dialog',
    templateUrl: './release-history-dialog.component.html',
    styleUrls: ['./release-history-dialog.component.css', '../../home/home.component.css'],
    standalone: false
})
export class ReleaseHistoryDialogComponent implements OnInit {
  releaseDefinitionRevision: string = '';
  dataSource = new MatTableDataSource<ReleaseDefinitionRevision>();
  displayedColumns: string[] = ['changedBy', 'changeType', 'changedDate', 'comment'];

  constructor(
    private dialogRef: MatDialogRef<ReleaseHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { releaseDefHistory: ReleaseDefinitionRevision[] }
  ) { }

  ngOnInit(): void {
    this.dataSource.data = this.data.releaseDefHistory;
  }

  update(selectedRevision: ReleaseDefinitionRevision): void {
    this.dialogRef.close(selectedRevision);
  }
}